import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  onConfirm: () => void
}

const ConfirmUpdateModal = ({ onClose, onConfirm }: Props) => {
  return (
    <Modal
      illustration="alert"
      title={i18n.t(
        'time_tracking.settings.work_time_categories.extra_hours_calculation.confirm_update_modal.title'
      )}
      description={i18n.t(
        'time_tracking.settings.work_time_categories.extra_hours_calculation.confirm_update_modal.description'
      )}
      onSubmit={onConfirm}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="primary" submit>
            {i18n.t('common.ok')}
          </Button>
        </>
      }
    />
  )
}

export default ConfirmUpdateModal
